export default "__VITE_ASSET__B9YfK3Ko__"